export default "__VITE_ASSET__CFKNCfRz__"